import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './Features.css';
import { NavigationLinkTypes } from '../../constants/navigation';
import { IFeatureSchema } from '../../types';
import { isArrayWithItems } from '../../utils/helpers';
import { HorizontalScroll } from '../HorizontalScroll';

export interface IFeaturesProps {
  featureList: IFeatureSchema[];
}

export interface IFeaturesDispatchProps {
  setNavigationLink(): void;
}

export type IFeaturesPropsValue = IFeaturesProps & IFeaturesDispatchProps;

export class Features extends React.Component<IFeaturesPropsValue> {
  public componentDidMount() {
    const { featureList } = this.props;
    if (isArrayWithItems(featureList)) {
      this.props.setNavigationLink();
    }
  }

  public render() {
    const { featureList } = this.props;
    if (!isArrayWithItems(featureList)) {
      return <div />;
    }

    return (
      <div className={styles['container']} id={NavigationLinkTypes.Features}>
        <h2 className={styles['title']}>Особенности</h2>
        <HorizontalScroll arrowStyles={styles['arrow']} containerStyle={styles['scroll']}>
          {featureList.map((feature, index) => (
            <div key={`feature_${index}`} className={styles['feature']}>
              {feature.imageUrl ? (
                <img className={styles['icon']} src={feature.imageUrl} alt={feature.description} />
              ) : (
                <div {...mergeStyles(styles['icon'], styles['icon--default'])} />
              )}
              <div className={styles['description']}>{feature.description}</div>
            </div>
          ))}
        </HorizontalScroll>
      </div>
    );
  }
}
